// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vh-45[data-v-2c471e22]{height:45vh;overflow:auto}.card-noti[data-v-2c471e22]{cursor:pointer}.card-noti[data-v-2c471e22]:hover{background:#ececec}#notification-dropdown[data-v-2c471e22]  .badge.badge-up.badge-pill.bg-danger.badge-glow{top:-8px}@media(max-width:576px){#notification-dropdown[data-v-2c471e22]  .badge.badge-up.badge-pill.bg-danger.badge-glow{top:-11px}}.custom_class[data-v-2c471e22]  .dropdown-menu{top:25px!important}", ""]);
// Exports
module.exports = exports;
